export const iconFontAwesomeWeatherMoon = (
	<i className="fa-solid fa-moon"></i>
);
